import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { CDN_URL, DEBUG, PAGE_PUBLIC, PAYFRONT_KEY } from './CheckoutConfig';
import { Outlet, RouterProvider, createBrowserRouter, useLocation, useRouteError } from 'react-router-dom';
import { SitePrivacy } from '@arema/components';
import { TitleProvider } from '@arema/components/Hooks';
import { addCommas } from '@arema/components/Util';
import { Header, Toast } from 'react-frontier';
import { initReactI18next, useTranslation } from 'react-i18next';
import { Checkout, Payment } from './screens';
import { PayfrontProvider } from 'react-payfront';
import Locale from '@arema/components/src/locale';
import i18n from 'i18next';

import 'fomantic-ui-css/semantic.css';
import 'frontier-css/css/frontier.css';
import './styles/checkout.scss'

i18n.use(initReactI18next).use(Locale('checkout')).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

i18n.services.formatter.addCached('commas', (lng, options: { fixed: boolean, hideZero: boolean })=>{
	return val=>{
		return addCommas(val, options.fixed!==false, options.hideZero===true);
	}
})

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var ErrorElement = ()=>{
	var { t } = useTranslation();
	const error = (useRouteError() as any);
	return <div>
		<div className="fr centered header" style={{ fontSize: 100 }}>
			{error.status}
			<div className="sub header" style={{ fontSize: 20 }}>
				{error.status===404 ? t('common.notfound') : t('common.unexpected_code', { type: '', code: `HT/${error.status}` })}
			</div>
		</div>
	</div>
}

var PublicRedirect = ()=>{
	var IS_DEBUG = !!DEBUG
	useEffect(()=>{
		if(!IS_DEBUG){
			window.location.href = process.env.REACT_APP_PAGE_PUBLIC;
		}
	}, []);

	return IS_DEBUG ? <Header text='Redirect DEV' /> : null;
}

var SiteContainer = (props: { outlet: JSX.Element })=>{
	var fullscreen = ['/frame'];
	var { t } = useTranslation();
	var location = useLocation();
	var is_fullscreen = useMemo(()=>{
		for(var i of fullscreen){
			if(location.pathname.startsWith(i)) return true;
		}
		return false;
	}, [location.pathname])

	return <TitleProvider suffix={t('common.site')}>
		<Toast.Provider>
			<PayfrontProvider apiKey={PAYFRONT_KEY} applePay>
				{!is_fullscreen && (
					<div className="ar header">
						<a href={PAGE_PUBLIC}>
							<img src={`${CDN_URL}/logo/LogoWH_Large.png`} alt={t('common.site')} />
						</a>
					</div>
				)}
				<div style={{ paddingBottom: 50, marginTop: is_fullscreen ? 0 : 20 }}>
					{props.outlet}
				</div>
			</PayfrontProvider>
		</Toast.Provider>
	</TitleProvider>
}

const Router = createBrowserRouter([{
	path: '/',
	errorElement: <ErrorElement />,
	element: <SiteContainer outlet={<Outlet />} />,
	children: [
		{ path: '/', element: <PublicRedirect /> },
		{ path: '/privacidad', element: <SitePrivacy /> },
		{ path: '/frame/:date', element: <Checkout fullscreen /> },
		{ path: '/:date', element: <Checkout /> }, 
		{ path: '/c/:token', element: <Payment /> },
		{ path: '/c/:token/pago', element: <Payment payment /> },
	]
}]);

root.render((
	<RouterProvider router={Router} />
));